import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import { Field, Fields, reduxForm } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';
import DatepickerField from 'components/fields/DatepickerField';
import TimepickerField from 'components/fields/TimepickerField';

import orderLinePlacesOfService from 'config/orderLinePlacesOfService';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import dateFormat from 'config/dateFormat';

import DeliveryDialogDriverFields from './DeliveryDialogDriverFields';

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
});

function onChange(values, dispatch, props, prevValues) {
  if (values.dateOfDelivery && !prevValues.dateOfDelivery && !values.timeOfDelivery) {
    dispatch(props.change('timeOfDelivery', '09:00 am'));
  }
  if (values.dateOfDelivery && !prevValues.dateOfDelivery && !values.timeOfDelivery) {
    dispatch(props.change('timeOfDelivery', '09:00 am'));
  }
  if (values.driverID
    && values.selectedDriverName
      !== values.driverName) {
    dispatch(props.change('driverID', ''));
  }
};

const validateForm = (values) => {
  const errors = {};
  if (values.dateOfDelivery && !values.timeOfDelivery) {
    errors.timeOfDelivery = 'Please, enter also time';
  }
  if (values.timeOfDelivery && !values.dateOfDelivery) {
    errors.dateOfDelivery = 'Please, enter also date';
  }
  return errors;
};

const CMNSelectionForm = ({ handleSubmit, className, formValues, variant, classes }) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
    role="presentation"
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
      }
    }}
  >
    {variant === 'default' &&
      <Grid
        className={classes.grid}
        container
        justify="flex-start"
        wrap="nowrap"
        spacing={16}
      >
        <Grid item xs={9} md={8}>
          <Fields
            names={[
              'driverName',
              'selectedDriverName',
              'driverID',
            ]}
            component={DeliveryDialogDriverFields}
            formValues={formValues}
          />
        </Grid>
        <Grid item xs={3} md={4}>
          <Field
            id="placeOfSRV"
            name="placeOfSRV"
            label="Place of SRV"
            component={AutosuggestField}
            validate={[validate.required]}
            normalize={normalize.number}
            placeholder="-Place of SRV-"
            fullWidth
            listWidth="auto"
            renderSuggestionContent={suggestion => `${suggestion.code}: ${suggestion.name}`}
            onSuggestionSelected={(suggestion) => {
              return suggestion.code;
            }}
            fetchSuggestions={({ value, offset }) => (new Promise((resolve) => {
              if (offset === 0) {
                if (value.length > 0) {
                  resolve(orderLinePlacesOfService.filter(item =>
                    item.code.indexOf(value) === 0));
                } else {
                  resolve(orderLinePlacesOfService);
                }
              } else {
                resolve([]);
              }
            }))}
          />
        </Grid>
      </Grid>
    }
    <Grid
      container
      justify="flex-start"
      wrap="nowrap"
      spacing={16}
    >
      <Grid
        item
        xs={variant === 'no-driver' ? 5 : 6}
      >
        <Field
          id="dateOfDelivery"
          name="dateOfDelivery"
          label="Date of Delivery"
          component={DatepickerField}
          validate={[validate.date]}
          normalize={normalize.date}
          fullWidth
          minDate="01/01/1900"
          maxDate="01/01/2100"
          dateFormat={dateFormat}
          placeholder="mm/dd/yyyy"
          maxLength="10"
          endIcon="start"
          inputAdornmentLgOnly
        />
      </Grid>
      <Grid
        // className={classes.gridTimeOfDelivery}
        item
        xs={variant === 'no-driver' ? 4 : 6}
      >
        <Field
          id="timeOfDelivery"
          name="timeOfDelivery"
          label="Time of Delivery"
          component={TimepickerField}
          validate={[validate.time, validate.timeOfDelivery]}
          normalize={normalize.timeDefaultPeriodAuto}
          placeholder="hh:mm am"
          fullWidth
          endIcon
          inputAdornmentLgOnly
        />
      </Grid>
      {variant === 'no-driver' &&
        <Grid item xs={3}>
          <Field
            id="placeOfSRV"
            name="placeOfSRV"
            label="Place of SRV"
            component={AutosuggestField}
            validate={[validate.required]}
            normalize={normalize.number}
            placeholder="-Place of SRV-"
            fullWidth
            listWidth="auto"
            renderSuggestionContent={suggestion => `${suggestion.code}: ${suggestion.name}`}
            onSuggestionSelected={(suggestion) => {
              return suggestion.code;
            }}
            fetchSuggestions={({ value, offset }) => (new Promise((resolve) => {
              if (offset === 0) {
                if (value.length > 0) {
                  resolve(orderLinePlacesOfService.filter(item =>
                    item.code.indexOf(value) === 0));
                } else {
                  resolve(orderLinePlacesOfService);
                }
              } else {
                resolve([]);
              }
            }))}
          />
        </Grid>
      }
    </Grid>
  </form>
);

CMNSelectionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  variant: PropTypes.oneOf(['default', 'no-driver']),
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

CMNSelectionForm.defaultProps = {
  className: '',
  formValues: {},
  variant: 'default',
};

export default reduxForm({
  onSubmit: values => values,
  onChange,
  validate: validateForm,
})(withStyles(styles)(CMNSelectionForm));



// WEBPACK FOOTER //
// ./src/components/workflow/DeliveryDialog/DeliveryDialogForm.js